<machine-form
  *ngIf="machine"
  [processing]="processing"
  [machine]="machine"
  (toggleCreateMachine)="update($event)"
  (toggleCancel)="goToBack()"
>
</machine-form>
